module.exports = __webpack_public_path__ + "static/bambam-dd294fdacd750105d492c56d4e8c16f3.gif";